// Oma Riista import helpers (CLUB-190). Oma Riista is the Finnish Wildlife
// Agency service; a hunting-area boundary can be imported by its public
// 10-character area code.

// Normalize a user-typed area code: trim only. Oma Riista codes are
// CASE-SENSITIVE at the Tanger backend, so we must NOT uppercase — a
// mixed-case code like "c8x9zJFwNR" must reach the server exactly as entered
// (uppercasing it 404'd every mixed-case code).
export function normalizeAreaCode(raw: string): string {
  return raw.trim()
}

/** A syntactically plausible Oma Riista code — 10 alphanumeric chars, any case. */
export function isValidAreaCode(raw: string): boolean {
  return /^[A-Za-z0-9]{10}$/.test(normalizeAreaCode(raw))
}

/**
 * Result of an Oma Riista import attempt. Success maps to created vs refreshed;
 * `not-found` is a genuinely unknown code; `error` carries the backend's stable
 * error code (e.g. `oma_riista.login_rejected`) so the UI can show it for
 * support without the shared component depending on the domain's ApiError.
 */
export type OmaRiistaImportResult =
  | { status: 'created' }
  | { status: 'refreshed' }
  | { status: 'not-found' }
  | { status: 'error'; code: string | null }
